const ProductSizeDisplay = Object.freeze({
  size_xxs: 'XXS / 32 / 4',
  size_xs: 'XS / 34 / 6',
  size_s: 'S / 36 / 8',
  size_m: 'M / 38 / 10',
  size_l: 'L / 40 / 12',
  size_xl: 'XL / 42 / 14',
  size_xxl: 'XXL / 44 / 16',
  size_xxxl: 'XXXL / 46 / 18',
  size_4xl: '4XL / 48 / 20',
  one_size: 'One size',
  kids: 'Kids',
});

const ProductConditionDisplay = Object.freeze({
  neu: 'Neu',
  sehr_gut: 'Sehr gut',
  gut: 'Gut',
  akzeptabel: 'Akzeptabel',
  schlecht: 'Schlecht',
});

const ProductGenderDisplay = Object.freeze({
  male: 'Herren',
  female: 'Frauen',
  unisex: 'Unisex',
});

export { ProductSizeDisplay, ProductConditionDisplay, ProductGenderDisplay };
